module.exports = __webpack_public_path__ + "static/img/mobileicon.1791aa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/front/mobileicon.png
// module id = RVzL
// module chunks = 1